import { IconCheckBold } from 'src/assets/icons/IconCheckBold';
import { ChevronIcon } from 'src/components/ChevronIcon';
import { ContextMenu } from 'src/components/ContextMenu';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { EDITOR_LABEL_MAP, EDITOR_TYPE } from 'src/data/project';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles.js';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

export const EditorTypeDropdown = ({ onChange, editorType }) => {
  const styles = useStyles();

  const setEditorType = (type) => {
    onChange(type);
  };

  const alignLabel = (label) => `Create with ${label.replace(' ', '-').toLowerCase()} editor`;

  const menuItems = Object.keys(EDITOR_TYPE).map((item) => ({
    id: EDITOR_TYPE[item],
    label: alignLabel(EDITOR_LABEL_MAP[EDITOR_TYPE[item]]),
    name: EDITOR_LABEL_MAP[EDITOR_TYPE[item]],
    icon: (
      <IconCheckBold
        className={editorType === EDITOR_TYPE[item] ? styles.iconCheck : styles.iconHidden}
      />
    ),
    onClick: () => {
      setEditorType(EDITOR_TYPE[item]);
    },
  }));

  return (
    <ContextMenu
      classes={{ menuRoot: styles.menuRoot }}
      renderButton={(props) => (
        <CustomTooltip title={menuItems.find((item) => item.id === editorType)?.label}>
          <CustomButton
            className={styles.root}
            variant={CUSTOM_BUTTON_VARIANT.text}
            size={CUSTOM_BUTTON_SIZE.smaller}
            endIcon={
              <ChevronIcon
                className={styles.iconChevron}
                direction={props.open ? ROTATE_DIRECTION.up : ROTATE_DIRECTION.down}
              />
            }
            {...props}
          >
            {menuItems.find((item) => item.id === editorType)?.name || 'Select Editor'}
          </CustomButton>
        </CustomTooltip>
      )}
      items={menuItems}
      menuProps={MENU_PROPS}
    />
  );
};
